import { render, staticRenderFns } from "./ScreenSharePage.vue?vue&type=template&id=ae57f85e&scoped=true&"
import script from "./ScreenSharePage.vue?vue&type=script&lang=js&"
export * from "./ScreenSharePage.vue?vue&type=script&lang=js&"
import style0 from "./ScreenSharePage.vue?vue&type=style&index=0&id=ae57f85e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae57f85e",
  null
  
)

export default component.exports